// extracted by mini-css-extract-plugin
export default {"icon":"icon--sMVCP","wrapper":"wrapper--kHIRW","expandLess":"expandLess--iqAfH","label":"label--zygYm"};